import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsDistributionLists = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/distribution-lists/lookups`);
	return data;
};

export const getDistributionLists = async (filters) => {
	const params = { ...filters };

	if (params.per_page) {
		params.page_size = params.per_page;
		delete params.per_page;
	}

	const { data } = await axios.get(`${API}/app/maintainer/distribution-lists`, { params });
	return data;
};

export const getDistributionList = async (slug) => {
	const { data } = await axios.get(`${API}/app/maintainer/distribution-lists/${slug}`);
	return data;
};

export const createDistributionList = async (form, filters = {}) => {
	const payload = { form, filters };
	const { data } = await axios.post(`${API}/app/maintainer/distribution-lists`, payload);
	return data;
};

export const updateDistributionList = async (listId, form, filters = {}) => {
	const payload = { form, filters };
	const { data } = await axios.put(`${API}/app/maintainer/distribution-lists/${listId}`, payload);
	return data;
};

export const deleteDistributionList = async (listId) => {
	const { data } = await axios.delete(`${API}/app/maintainer/distribution-lists/${listId}`);
	return data;
};
